"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Main_1 = __importDefault(require("@/components/Main"));
const TitleSection_1 = __importDefault(require("@/components/DynamicTable/TitleSection"));
const SearchCountriesAutocomplete_1 = __importDefault(require("../SearchCountriesAutocomplete"));
const PortsTable_1 = __importDefault(require("../PortsTable"));
const style_1 = require("./style");
function ListPortsSectionView({ shouldShowPortsTable }) {
    return (react_1.default.createElement(Main_1.default, null,
        react_1.default.createElement(Grid_1.default, { container: true },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(TitleSection_1.default, { title: "Ports" })),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 6 },
                react_1.default.createElement(style_1.SelectDescription, { variant: "h4" },
                    " ",
                    "Select a country below to list the ports associated to it"),
                react_1.default.createElement(SearchCountriesAutocomplete_1.default, null)),
            shouldShowPortsTable && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sx: style_1.tablesSectionstyle },
                react_1.default.createElement(PortsTable_1.default, null))))));
}
exports.default = ListPortsSectionView;
